import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/medioCamp.actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.CAMPAIGNS2_CLEAR:
      return []
    case Actions.LIST2_MEDIUM:
      return [...state, action.mediumbannerstype]
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}